'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import allTags from '../../../tables/tags';

import './SkillLevel.scss';

export default class SkillLevel extends Component {
    static propTypes = {
        params: PropTypes.object,
        onChangeParams: PropTypes.func,
    };

    setSkillLevel = (skillLevel) => {
        const { params, onChangeParams } = this.props;

        params.filters = params.filters || {};

        // Remove skill level tags from filter in and filter out tags
        params.filters['!tags'] = (params.filters['!tags'] || []).filter(tag => !allTags.skill.tags.includes(tag));
        params.filters.tags     = (params.filters.tags || []).filter(tag => !allTags.skill.tags.includes(tag));

        if (skillLevel == 'Beginner') {
            params.filters['!tags'].push('Intermediate');
            params.filters['!tags'].push('Advanced');
        } else if (skillLevel == 'Intermediate') {
            params.filters['!tags'].push('Advanced');
        } else if (skillLevel == 'Advanced') {
            params.filters.tags.push('Advanced');
        }

        onChangeParams(params);
    }

    render() {
        const { params } = this.props;

        const filterInTags  = (params.filters.tags || []);
        const filterOutTags = (params.filters['!tags'] || []);

        let skillType = false;

        if (filterOutTags.includes('Intermediate') && filterOutTags.includes('Advanced')) {
            skillType = 'Beginner';
        } else if (!filterOutTags.includes('Intermediate') && filterOutTags.includes('Advanced')){
            skillType = 'Intermediate';
        } else if (filterInTags.includes('Advanced')) {
            skillType = 'Advanced';
        }

        return (
            <div className="skill-level-filter">
                <ul>
                    <li>
                        <button className="el-radio-btn" data-active={skillType == false}
                            onClick={e => this.setSkillLevel(false)}>
                            All Skill Levels (default)
                        </button>
                    </li>
                    <li>
                        <button className="el-radio-btn" data-active={skillType == 'Beginner'}
                            onClick={e => this.setSkillLevel('Beginner')}>
                            Beginner
                        </button>
                    </li>
                    <li>
                        <button className="el-radio-btn" data-active={skillType == 'Intermediate'}
                            onClick={e => this.setSkillLevel('Intermediate')}>
                            Intermediate
                        </button>
                    </li>
                    <li>
                        <button className="el-radio-btn" data-active={skillType == 'Advanced'}
                            onClick={e => this.setSkillLevel('Advanced')}>
                            Advanced
                        </button>
                    </li>
                </ul>
            </div>
        );
    }
}
